<template>
  <div class="task-card">
    <div style="display: flex; cursor: pointer;" @click="openBoard = !openBoard">
      <p v-if="!openBoard" style="font-size:6px; padding-top:5px;">▶︎　</p>
      <p v-else style="font-size:6px; padding-top:5px;">▼　</p>
      <p>{{ trello_board.name }}</p>
    </div>
    <template v-for="(list, idx) in trelloListList">
      <TrelloList
        v-if="openBoard && list.board_id == trello_board.board_id"
        :key="idx"
        :trello_list="list"
        :trelloCardList="trelloCardList"
        @changeEditTaskView="changeEditTaskView"
        @changeDeleteTaskView="changeDeleteTaskView"
        @changeSendTaskView="changeSendTaskView"
        @updateUserTaskLog="updateUserTaskLog"
        @createEvent="createEvent"
        @dragTask="dragTask"
        @dragendTask="dragendTask"
      />
    </template>
  </div>
</template>

<script>
import Tooltip from "@/components/atoms/tooltips/Tooltip";
import TrelloList from "@/components/Calendar/organisms/TrelloList";
export default {
  components: {
    Tooltip,
    TrelloList,
  },
  props: {
    trello_board: {
      type: Object,
      required: true,
    },
    trelloListList: {
      type: Array,
      required: true,
    },
    trelloCardList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    unreadCnt() {
      let cnt = 0;
      this.task.send_user_task_log.forEach((v) => {
        if (!v.is_read) cnt++;
      });
      return cnt;
    },
  },
  data() {
    return {
      openBoard: false,
      createTask: {
        title: null,
        description: null,
        time_min: 60,
        file: [],
      },
    };
  },
  methods: {
    changeEditTaskView(data) {
      this.$emit("changeEditTaskView", data);
    },
    changeDeleteTaskView(data) {
      this.$emit("changeDeleteTaskView", data);
    },
    changeSendTaskView(data) {
      this.$emit("changeSendTaskView", data);
    },
    createEvent(data) {
      this.$emit("createEvent", data);
    },
    changeCreateTaskView(flg) {
      this.$emit("changeCreateTaskView", flg);
    },
    changeModalTask(flg) {
      this.$emit("changeModalTask", flg);
    },
    changeModalTaskLog(flg) {
      this.$emit("changeModalTaskLog", flg);
    },
    changeModalLinkTrello(flg) {
      this.$emit("changeModalLinkTrello", flg);
    },
    updateUserTaskLog(log) {
      this.$emit("updateUserTaskLog", log);
    },
    onDropTask() {
      this.$emit("createEvent", this.draggingTask);
    },
    dragTask(task) {
      this.$emit("dragTask", task);
    },
    dragendTask(task) {
      this.$emit("dragendTask", task);
    },
    onDragover(event) {
      event.preventDefault();
    },
  },
};
</script>

<style lang="scss" scoped>
.task-card {
  width: 200px;
  border-radius: 8px;
  padding: 16px;
  margin: 12px;
  border: solid thin #ccc;
  text-align: left;
  background: #e7e7e7;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/Calendar/organisms/TrelloBoard.vue